import React from 'react';
import { motion } from 'framer-motion';
import { Breadcrumb } from '../components/Breadcrumb';

export default function PrivacyPolicyPage() {
  return (
    <div className="page-transition min-h-screen bg-stone-50">
      <section className="bg-white border-b border-stone-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Breadcrumb items={[{ label: 'Privacy Policy' }]} />
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-2xl p-8 md:p-12 shadow-soft"
          >
            <h1 className="font-heading font-bold text-3xl text-stone-900 mb-8">
              Privacy Policy
            </h1>

            <div className="prose prose-stone max-w-none">
              <p className="text-stone-600 mb-6">
                Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
              </p>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                1. Information We Collect
              </h2>
              <p className="text-stone-600 mb-4">
                We collect information you provide directly to us, including:
              </p>
              <ul className="list-disc pl-6 text-stone-600 mb-6 space-y-2">
                <li>Name, email address, and phone number when you contact us or submit inquiries</li>
                <li>Company information when you apply to become a dealer</li>
                <li>Location information for regional product recommendations</li>
                <li>Any other information you choose to provide</li>
              </ul>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                2. How We Use Your Information
              </h2>
              <p className="text-stone-600 mb-4">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 text-stone-600 mb-6 space-y-2">
                <li>Respond to your inquiries and provide customer support</li>
                <li>Process dealer applications and partnerships</li>
                <li>Send you updates about our products and services</li>
                <li>Improve our website and services</li>
                <li>Comply with legal obligations</li>
              </ul>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                3. Information Sharing
              </h2>
              <p className="text-stone-600 mb-6">
                We do not sell, trade, or otherwise transfer your personal information to third parties without 
                your consent, except as described in this policy or as required by law. We may share your 
                information with trusted service providers who assist us in operating our website and conducting 
                our business.
              </p>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                4. Data Security
              </h2>
              <p className="text-stone-600 mb-6">
                We implement appropriate security measures to protect your personal information against 
                unauthorized access, alteration, disclosure, or destruction. However, no method of transmission 
                over the Internet or electronic storage is 100% secure.
              </p>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                5. Cookies and Tracking
              </h2>
              <p className="text-stone-600 mb-6">
                We may use cookies and similar tracking technologies to enhance your experience on our website. 
                You can set your browser to refuse cookies, but some features of the website may not function 
                properly without them.
              </p>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                6. Your Rights
              </h2>
              <p className="text-stone-600 mb-4">
                You have the right to:
              </p>
              <ul className="list-disc pl-6 text-stone-600 mb-6 space-y-2">
                <li>Access, correct, or delete your personal information</li>
                <li>Opt-out of marketing communications</li>
                <li>Request a copy of your data</li>
                <li>Lodge a complaint with a supervisory authority</li>
              </ul>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                7. Contact Us
              </h2>
              <p className="text-stone-600 mb-6">
                If you have any questions about this Privacy Policy, please contact us at:
              </p>
              <div className="bg-stone-50 rounded-lg p-4 text-stone-600">
                <p><strong>Dream Field Agri solution</strong></p>
                <p>123 Agriculture Road</p>
                <p>Farmville, State 12345</p>
                <p>Email: agrisolutiondreamfield@gmail.com</p>
                <p>Phone: +1 234 567 890</p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
